import React from 'react'
import { Model, useValue, WhenModel } from '@morningtrain/react-resources'

export default function ReadSchedule ({ children }) {
  const id = useValue('id')

  return (
    <Model resourceName='shifts.schedule' operationName='read' id={id} clean>
      <WhenModel>
        {children}
      </WhenModel>
    </Model>
  )
}
